import React from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

/**
 * Hides main site chrome on admin routes (marketing UI unchanged on public pages).
 */
const AppShell = ({ children }) => {
  const { pathname } = useLocation();
  const isAdminArea =
    pathname.startsWith('/admin') || pathname === '/dashboard';

  return (
    <>
      {!isAdminArea && <Navigation />}
      {children}
      {!isAdminArea && <Footer />}
      {!isAdminArea && <WhatsAppButton />}
    </>
  );
};

export default AppShell;
